import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL_LOGIN, SECRET_SESSION } from "../constants";
import { decrypt_res, encrypt_res } from "../components/shares/GlobalFunction";
import moment from "moment-timezone";

const initialState = {
  user: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const LoginUser = createAsyncThunk(
  "user/LoginUser",
  async (user, thunkAPI) => {
    if (user.username === "" || user.password === "") {
      const message = "Silahkan lengkapi username dan password anda !";
      return thunkAPI.rejectWithValue(message);
    } else {
      try {
        let token = localStorage.getItem("user");
        const payload = {
          username: user.username,
          password: user.password,
          timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        const encryptedPayload = encrypt_res(
          JSON.stringify(payload),
          SECRET_SESSION
        );
        const response = await axios.post(API_URL_LOGIN + "/login/proses", {
          // username: user.username,
          // password: user.password,
          data: encryptedPayload,
          token: token,
        });
        // const decResponse = JSON.parse(
        //   decrypt_res(response.data, SECRET_SESSION)
        // );

        // alert(JSON.stringify(response));

        // console.log("decResponse", decResponse);

        return response.data;
      } catch (error) {
        if (error.response) {
          const message = error.response.data.msg;
          return thunkAPI.rejectWithValue(message);
        }
      }
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(LoginUser.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(LoginUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.user = action.payload;
    });

    builder.addCase(LoginUser.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    });
  },
});

export const { reset } = authSlice.actions;

export default authSlice.reducer;
